export const messages = {
  'de-DE': {
    general: {
      dataNotAvailable: 'nicht verfügbar',
      enabled: 'aktiviert',
      disabled: 'deaktiviert',
      requestedUpdate: 'Angeforderte Aktualisierung',
      becomes: 'wird',
      save: 'Speichern',
      cancel: 'Abbrechen',
    },
    noThingSelectedState: {
      heading: 'Kein SRT-Gerät ausgewählt',
      text: 'Derzeit wurde noch kein SRT-Gerät ausgewählt. Bitte nutzen Sie die Suchfunktion und tragen Sie ihre gewünschte SRT-Seriennummer ein.',
    },
    notAuthorized: {
      heading: 'Kein Zugriff',
      text: 'Sie haben leider keine Berechtigung diese Seite zu aufzurufen.',
    },
    loadingStates: {
      actionTakesSomeTime:
        'Es kann ein paar Minuten dauern, bis die Aktion erfolgreich abgeschlossen ist.',
      actionFailed: 'Aktion fehlgeschlagen.',
      contactDevDepartment: 'Bitte kontaktieren Sie die Entwicklungsabteilung.',
      calibrating: 'Kalibrieren ...',
      rebooting: 'Rebooten ...',
    },
    successStates: {
      actionSuccessful: 'Aktion erfolgreich.',
      updatedSrtInTicket: 'Die SRT-Gerätedaten im Ticket wurden erfolgreich aktualisiert.',
    },
    srtActions: {
      srtFunctionalities: 'Zusätzliche Funktionen',
      rebootSrt: 'Reboot',
      lastReboot: 'Letzter Reboot:',
      calibrateSrt: 'Kalibrierung',
      lastCalibration: 'Letzte Kalibrierung:',
      initiateCalibrationTicketComment: 'Kalibrierung wurde initiiert für { ticketSrtSerial }',
      initiateRebootTicketComment: 'Reboot wurde initiiert für { ticketSrtSerial }',
      loadThing: 'SRT-Gerät laden',
    },
    childLock: {
      childLock: 'Kindersicherung',
      childLockOn: 'aktiviert',
      childLockOff: 'deaktiviert',
      childLockTicketComment: 'Kindersicherung wurde { state } für { ticketSrtSerial }',
      childLockProgressTooltip:
        'Der Wechsel kann einige Minuten dauern. Bitte warten. Derzeit ist die Kindersicherung { state }',
      childLockSuccessUpdateToast: 'Kindersicherung ist erfolgreich aktualisiert worden!',
    },
    temperatureOffset: {
      temperatureOffset: 'Temperatur-Offset',
      invalidValueDescription: 'Der Wert sollte eine Zahl zwischen -3 und +3 sein.',
      progressTooltip:
        'Der Wechsel kann einige Minuten dauern. Derzeit ist das Temperatur-Offset { value }°C',
      successUpdateToast: 'Temperatur-Offset ist erfolgreich aktualisiert worden!',
      temperatureOffsetTicketComment:
        'Temperatur-Offset ist auf { temperatureOffset } geändert für { ticketSrtSerial }',
      save: 'Speichern',
      cancel: 'Abbrechen',
      celsius: ' in °C',
      offsetInfo:
        'Ein Offset von +3°C bedeutet, dass der SRT 3°C unter der Solltemperatur heizt (z.B. nur bis 17°C statt 20°C). Bei negativem Offset entsprechend über der Solltemperatur.',
    },
    hydraulicBalancing: {
      motorLimit: 'Öffnungsbegrenzung',
      absolute: '(absolut)',
      relative: '(relativ)',
      heatControl: 'Heizreglung',
      hydraulicBalancing: 'Ventilöffnungsbegrenzung',
      hydraulicBalancingTicketComment:
        'Ventilöffnungsbegrenzung  ist { state } für { ticketSrtSerial }',
      enableForDevice: 'Für dieses Gerät aktivieren',
      disableForDevice: 'Für dieses Gerät deaktivieren',
      hydraulicBalancingProgressTooltip: 'Der Wechsel kann einige Minuten dauern. Bitte warten.',
      invalidMotorLimitError: 'Der Wert sollte eine Zahl zwischen { min } und { max } sein.',
      motorLimitProgressTooltip:
        'Der Wechsel kann einige Minuten dauern. Bitte warten. Derzeit ist die Öffnungsbegrenzung { currentMotorLimit }μm',
      motorLimitModeTooltip:
        'Neuere Firmware-Versionen nutzen aufgrund der Ventildichtungs-Erkennung eine relative Einstellung der Öffnungsbegrenzung. ' +
        'Ein Wert von 0 entspricht dem Wert von 1000 in früheren Firmware-Versionen. ' +
        'Positive Werte bedeuten gegenüber den Werkseinstellungen einen vergrößerten Öffnungsbereich, negative Werte einen begrenzten.',
      motorLimitSuccessUpdateToast: 'Öffnungsbegrenzung ist erfolgreich aktualisiert worden!',
      motorLimitTicketComment:
        'Öffnungsbegrenzung ist auf { motorLimit } geändert für { ticketSrtSerial }',
      valveOpening: 'Ventilöffnung',
      targetTemperature: 'Eingestellte Zieltemperatur',
      dateOfLastTemperatureSetting: 'Letzte Zieltemperaturänderung',
      measuredTemperature: 'Gemessene Temperatur',
    },
    windowOpenDetectionStatus: {
      title: 'Fenster-Offen-Erkennung',
      windowState: 'Fensterstatus',
      opened: 'geöffnet',
      closed: 'geschlossen',
      lastDetected: 'Zuletzt geöffnet',
    },
    srtStatus: {
      volt: 'V',
    },
    additionalInformation: {
      lastLocation: 'Letzter Standort',
      lastDataTransfer: 'Letzter Datentransfer',
      roomType: 'Raumtyp',
      mountedOn: 'Montiert am',
      unMountedOn: 'Entfernt am',
      firmwareVersion: 'Firmware-Version',
      floorLevel: 'Etage',
      billingUnitReference: 'Abrechnungseinheit (AE)',
      customerNumber: 'Kundennummer',
      usageUnit: 'Nutzeinheit (NE)',
      address: 'Adresse',
      resident: 'Bewohner',
      unitIsVacant: 'Einheit ist im Leerstand',
      articleNumber: 'Artikelnummer',
      heatingDisruptionSuspected: 'Derzeit wird eine Störung im Gebäude vermutet – seit {start}',
      noHeatingDisruptionSuspected: 'Derzeit wird keine Störung im Gebäude vermutet',
    },
    roomGroupDeviceList: {
      coupledDevicesList: 'Gekoppelte Geräte',
      noCoupledDevices: 'Keine gekoppelten Geräte',
      deviceList: 'Geräte in anderen Räumen',
      noDeviceFound: 'Kein Gerät gefunden',
    },
    searchBarNavigation: {
      searchByDeviceDataLabel: 'Suche nach Seriennummer',
      searchByAENumberLabel: 'Suche nach AE-Nummer',
      searchByAddressLabel: 'Suche nach Adresse',
    },
    SearchDevices: {
      noDeviceFound: 'Leider konnten wir keine SRT-Geräte mit dieser Nummer finden.',
      searchPlaceholder: 'SRT-Seriennummer...',
      buttonSearch: 'Suchen',
      searchErrorMessage: 'Bitte geben Sie eine vollständige SRT-Seriennummer ein',
      ticketSrtSerialTransferError: 'Seriennummer aus Ticket fehlerhaft!',
    },
    searchProperties: {
      byBillingUnitNumber: {
        invalidSearchInput: 'Ungültige AE-Nummer',
        searchPlaceholder: 'AE-Nummer...',
        billingUnit: 'Abrechnungseinheit',
        noPropertiesFound: 'Leider konnten wir keine Gebäude mit dieser Nummer finden.',
        errorFetchProperties: 'Fehler beim Abrufen der Abrechnungseinheit.',
      },
      byAddress: {
        zipCodeInputLabel: 'PLZ',
        zipCodeInputPlaceholder: '10115',
        streetInputLabel: 'Straße',
        streetInputPlaceholder: 'Musterstraße',
        houseNumberInputLabel: 'Hausnr.',
        houseNumberInputPlaceholder: '12a',
        searchByAddress: 'Suche nach Adresse',
        searchParamsValidationError:
          'Bitte geben Sie eine gültige Postleitzahl (5 Ziffern) und mindestens 3 Zeichen für die Straße ein',
        noPropertiesFound: 'Leider konnten wir keine Gebäude mit dieser Adresse finden.',
        errorFetchProperties: 'Fehler beim Abrufen der Adresse.',
      },
      buttonSearch: 'Suchen',
      numberOfProperties: 'Gebäude insgesamt',
      noPropertiesFound: 'Keine Gebäude gefunden.',
      propertyList: 'Gebäudeliste',
      errorFetchOccupancies: 'Fehler beim Abrufen der Bewohnerliste.',
      floor: {
        upper: 'OG',
        basement: 'UG',
        ground: 'EG',
      },
      usageUnitId: 'NE',
      usageUnitIdNoValue: 'n/a',
      errorFetchDevices: 'Fehler beim Abrufen der Geräteliste.',
      noDevicesFound: 'Keine Geräte gefunden.',
    },
    deviceStatus: {
      popover: {
        title: 'Dimensionen des Gerätestatus',
        statusColumn: 'Status',
        messageColumn: 'Meldung',
      },
      dimension: {
        installation: 'Installation',
        connectivity: 'Verbindung',
        internal: 'Intern',
        analysis: 'Analyse',
        NONE_APPLICABLE: 'N/A',
      },
      cardinality: {
        '0': 'Leer',
        '10': 'Unbekannt',
        '20': 'Ok',
        '30': 'Ausstehend',
        '40': 'Warnung',
        '50': 'Fehler',
        '60': 'Kritisch',
      },
      notMounted: 'Nicht installiert!',
    },
    roomTypes: {
      HALLWAY_AND_STAIRCASE: {
        name: 'Treppenhaus',
        abbrev: 'TH',
      },
      CORRIDOR: {
        name: 'Flur',
        abbrev: 'FL',
      },
      BATHROOM: {
        name: 'Badezimmer',
        abbrev: 'BZ',
      },
      TOILET: {
        name: 'Toilette',
        abbrev: 'WC',
      },
      KITCHEN: {
        name: 'Küche',
        abbrev: 'KÜ',
      },
      LIVING_ROOM: {
        name: 'Wohnzimmer',
        abbrev: 'WZ',
      },
      DINING_ROOM: {
        name: 'Esszimmer',
        abbrev: 'EZ',
      },
      OFFICE: {
        name: 'Büro',
        abbrev: 'BÜ',
      },
      CHILDRENS_ROOM: {
        name: 'Kinderzimmer',
        abbrev: 'KiZ',
      },
      BEDROOM: {
        name: 'Schlafzimmer',
        abbrev: 'SZ',
      },
      GARAGE: {
        name: 'Garage',
        abbrev: 'GAR',
      },
      HEATER: {
        name: 'Heizung',
        abbrev: 'HZG',
      },
      ENGINEERING: {
        name: 'Technikraum',
        abbrev: 'TR',
      },
      BASEMENT: {
        name: 'Keller',
        abbrev: 'KEL',
      },
      POOL_OR_SAUNA: {
        name: 'Schwimmbad/Sauna',
        abbrev: 'SB/S',
      },
      ARCADE: {
        name: 'Spielzimmer',
        abbrev: 'SPZ',
      },
      OTHER: {
        name: 'Sonstiges',
        abbrev: 'SONST',
      },
      NONE_APPLICABLE: {
        name: 'N/A',
        abbrev: 'N/A',
      },
    },
    timeNotation: {
      justNow: 'gerade eben',
      minutesAgo: 'vor einer Minute | vor {n} Minuten',
      hoursAgo: 'vor einer Stunde | vor {n} Stunden',
      daysAgo: 'vor einem Tag | vor {n} Tagen',
      yearsAgo: 'vor einem Jahr | vor {n} Jahren',
    },
    translationMissing: '/',
  },
};
